module.exports = __webpack_public_path__ + "img/17.8720fc50.png";